export default "__VITE_ASSET__CEXnBjIw__"